// 公共工具类的


//跳转
export const toPage = (jumpUrl, cb) => {
    console.log('11111111', _multi_bridge);
    if (jumpUrl) {
        if (jumpUrl.indexOf("tctclient") === 0 || jumpUrl.indexOf("eltclient") === 0 ) {
            // 跳转原生
            // _multi_bridge.navigateTo({
            //     url: jumpUrl
            // })
            window.location.href = jumpUrl
        } else {
            if (jumpUrl.indexOf("/") === 0) {
                jumpUrl = location.href.substr(0, location.href.lastIndexOf("/")) + jumpUrl
            }
            window._tc_bridge_web.open_newurl({
                param: {
                    openParams: "newWindow,needSlide",
                    jumpUrl,
                },
                callback: cb
            })
        }
    }
}

// 比较app版本号大小
export const compareVersion =  (v1, v2)=>{
  const a = v1.split('.')
  const b = v2.split('.')
  const maxLength = Math.max(a.length, b.length)
  for (let i = 0; i < maxLength; i++) {
    const cur = a[i] || 0
    const next = b[i] || 0
    if (cur === next) continue
    return cur >= next ? 1 : -1
  }
  return 0
}

/**
 * 去除字符串中所有空格
 * @param {*} value 
 */
export const trimAll = (value = '') => {
    return value.replace(/\s*/g, "");
}

/**
 * 手机号344格式化
 * @param {*} phoneNum 
 */
export const formatPhone344 = (phoneNum) => {
    let len = phoneNum.length;
    phoneNum = phoneNum.replace(/\s*/g, "");

    if (len > 3 && len < 8) {
        phoneNum = phoneNum.substr(0, 3) + ' ' + phoneNum.substr(3)
    } else if (len >= 8) {
        phoneNum = phoneNum.substr(0, 3) + ' ' + phoneNum.substr(3, 4) + ' ' + phoneNum.substr(7);
    }

    return phoneNum;
}

// 手机号脱敏
export const phoneDesensitization = (phoneNum) => {
    phoneNum = phoneNum.replace(/(\d{3})\d*(\d{4})/, '$1****$2')
    return phoneNum;
}

// 校验姓名
export const checkName = (val) => {
    let p =
        /(^[\u4e00-\u9fa5]{1}[\u4e00-\u9fa5\\.·。]{0,18}[\u4e00-\u9fa5]{1}$)|(^[a-zA-Z]{1}[a-zA-Z\s]{0,18}[a-zA-Z]{1}$)/;
    if (p.test(val)) return true;
    else return false;
}

// 校验身份证号
export const checkIdno = (val) => {
    let p =
        /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
    let code = val.substring(17);
    if (p.test(val)) {
        let sum = 0;
        for (let i = 0; i < 17; i++) {
            sum += val[i] * factor[i];
        }
        if (parity[sum % 11] == code.toUpperCase()) {
            return true;
        }
    }
    return false;
}

// 校验残疾证号
export const checkDisabilityNo = (disabilityNo, idno) => {
    const length = disabilityNo.length;
    if (disabilityNo.indexOf(idno) == 0 && length > 18) {
        if (length == 20) {
            const str1 = disabilityNo.slice(18, 19);
            const str2 = disabilityNo.slice(19, 20);
            if (!(str1 == 2 || str1 == 3 || str1 == 7)) {
                return {
                    isTrue: false,
                    text: '所填残疾类型非听力障碍，不符合认证要求',
                };
            } else if (!(str2 == 1 || str2 == 2 || str2 == 3 || str2 == 4)) {
                return {
                    isTrue: false,
                    text: '请填写正确的残疾证号',
                };
            } else {
                return {
                    isTrue: true,
                    text: '',
                };
            }
        } else if (length == 22) {
            const str = disabilityNo.slice(20, 22);
            if (!(str == 'BB' || str == 'B1' || str == 'B2' || str == 'B3')) {
                return {
                    isTrue: false,
                    text: '请填写正确的残疾证号',
                };
            } else {
                return {
                    isTrue: true,
                    text: '',
                };
            }
        } else
            return {
                isTrue: false,
                text: '请填写正确的残疾证号',
            };
    } else {
        return {
            isTrue: false,
            text: '请填写正确的残疾证号',
        };
    }
}

// 校验手机号
export const checkPhone = (val) => {
    let p = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;
    if (p.test(val)) return true;
    return false;
}

// 随机数 随机字符串
export const randomString = (len) => {
    len = len || 32;
    let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    let maxPos = $chars.length,
        pwd = '';
    for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}

// 分享
export const onShare = (shareData, cb) => {
    const { tcsharetxt, tcsharedesc, tcshareurl, tcshareimg, wakeRefid, wakePid } = shareData
  // eslint-disable-next-line
    _tc_bridge_bar.shareInfoFromH5({
        param: {
        tcsharetxt, // 分享标题
        tcsharedesc, // 分享描述
        tcshareurl: `https://m.17u.cn/app/links/web/main_${randomString(18)}?url=${encodeURIComponent(tcshareurl)}&isback=true&wakeNew=1&wakeRetry=1&wakePwdId=0&wakeRefid=${wakeRefid}&wakePid=${wakePid}`, // wakeRefid: 渠道id，wakePid：0默认张子枫图，可配置其他图 
        tcshareimg  // 分享图标，正方形比列 大小建议为128k内 小程序分享图标 比例5:4
        },
        callback: cb
    })
}

export const isIOS = !!(
    ( typeof window !== 'undefined' &&
      window.navigator &&
      window.navigator.userAgent ) ||
    ''
  ).match( /\(i[^;]+;( U;)? CPU.+Mac OS X/ );
  
  export const isColor = function ( value ) {
    const colorReg = /^#([a-fA-F0-9]){3}(([a-fA-F0-9]){3})?$/;
    const rgbaReg = /^[rR][gG][bB][aA]\(\s*((25[0-5]|2[0-4]\d|1?\d{1,2})\s*,\s*){3}\s*(\.|\d+\.)?\d+\s*\)$/;
    const rgbReg = /^[rR][gG][bB]\(\s*((25[0-5]|2[0-4]\d|1?\d{1,2})\s*,\s*){2}(25[0-5]|2[0-4]\d|1?\d{1,2})\s*\)$/;
  
    return colorReg.test( value ) || rgbaReg.test( value ) || rgbReg.test( value );
  };